import React from "react";
import { ScenariosData } from "../../../data/scenarios.data";

interface Props {
  car: any;
  scenario: any;
  setScenario: (value: any) => void;
}

const SidebarScenario: React.FC<Props> = ({ car, scenario, setScenario}) => {
  
  const [scenarioList, setScenarioList] = React.useState<any>([]);
  
  React.useEffect(() => {
    if(car){
      const scenarios: any = ScenariosData();
      if(scenarios){
        const scenario_list: any = [];
        for (const scenario of scenarios) {
          if (scenario.active)
            scenario_list.push(scenario);
        }
        setScenarioList(scenario_list);
        // Solo inicializa: el componente se desmonta al ir a Interior o a la galería
        // y al volver debe conservar el escenario elegido.
        if(!scenario)
          setScenario(scenario_list[0]);
      }
    }
  }, [car, scenario, setScenario]);

  return (
    <div className="studio-sidebar-scenario">
      <div className="studio-sidebar-scenario-subcontainer">
        <div className='studio-sidebar-scenario-title'>Escenarios</div>
        <div className='studio-sidebar-scenario-selection'>
          {
            (scenarioList as {}[]).map((scenarioItem: any, index: number) =>
              <div key={scenarioItem.id} className={`studio-sidebar-scenario-button-container ${scenarioItem.id === scenario?.id ? 'selected':''}`} onClick={() => {if(scenarioItem.interactable === true){setScenario(scenarioItem)} }}>
                <div className={`studio-sidebar-scenario-button ${scenarioItem.id === scenario?.id ? 'selected':''}`}>
                  <div className={`studio-sidebar-scenario-text ${scenarioItem.id === scenario?.id ? 'selected':''}`}>{scenarioItem.name}</div>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default SidebarScenario;